<template>
  <div class="link-to-container">
    <label>跳转至:</label>
    <ul>
      <li 
        title="尺寸变换" 
        v-if="!hideResize" 
        @click="linkTo('resize')"
      >
        <a class="to-resize"></a>
      </li>
      <li
        title="图片压缩"
        v-if="!hideCompress"
        @click="linkTo('compress')"
      >
        <a class="to-compress"></a>
      </li>
      <li 
        title="格式转换" 
        v-if="!hideFormat" 
        @click="linkTo('format')"
      >
        <a class="to-format"></a>
      </li>
      <li
        title="添加水印"
        v-if="!hideWatermark"
        @click="linkTo('watermark')"
      >
        <a class="to-watermark"></a>
      </li>
      <li
        title="拼图"
        v-if="!hidePuzzle"
        @click="linkTo('puzzle')"
      >
        <a class="to-puzzle"></a>
      </li>
      <li
        title="图片裁剪"
        v-if="!hideCrop"
        @click="linkTo('crop')"
      >
        <a class="to-crop"></a>
      </li>
      <li
        title="添加文字"
        v-if="!hideText"
        @click="linkTo('text')"
      >
        <a class="to-text"></a>
      </li>
      
      <li 
        title="图片旋转" 
        v-if="!hideRotate" 
        @click="linkTo('rotate')"
      >
        <a class="to-rotate"></a>
      </li>
      
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    hideResize: {
      type: Boolean,
      default: false
    },
    hideRotate: {
      type: Boolean,
      default: false
    },
    hideFormat: {
      type: Boolean,
      default: false
    },
    hideCrop: {
      type: Boolean,
      default: false
    },
    hideText: {
      type: Boolean,
      default: false
    },
    hideWatermark: {
      type: Boolean,
      default: false
    },
    hidePuzzle: {
      type: Boolean,
      default: false
    },
    hideCompress: {
      type: Boolean,
      default: false
    },
    hideFlip: {
      type: Boolean,
      default: false
    },

    fileList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {

    }
  },
  methods: {
    linkTo (name) {
      this.$router.push({
        name: name,
        params: {
          fileList: this.fileList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.link-to-container {
  overflow: hidden;

  label {
    float: left;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
  ul {
    overflow: hidden;
    display: inline-block;
    height: 30px;

    li {
      float: left;
      margin-right: 5px;
      cursor: pointer;

      a {
        display: inline-block;
        width: 29px;
        height: 29px;
      }

      .to-resize {
        background: url('../../../assets/images/home/resize.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-rotate {
        background: url('../../../assets/images/home/rotate.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-format {
        background: url('../../../assets/images/home/format.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-crop {
        background: url('../../../assets/images/home/crop.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-text {
        background: url('../../../assets/images/home/text.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-watermark {
        background: url('../../../assets/images/home/watermark.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-puzzle {
        background: url('../../../assets/images/home/puzzle.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-compress {
        background: url('../../../assets/images/home/compress.png') no-repeat center;
        background-size: 100% 100%;
      }
      .to-flip {
        background: url('../../../assets/images/home/flip.png') no-repeat center;
        background-size: 100% 100%;
      }
    }
    li:last-child {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/LinkTo/index.vue